import React from 'react'
import { useBucket } from '@mc/experiments-react'
import { ContactForm as ContactFormV2 } from './ContactFormV2'
import { ContactForm as ContactFormV3 } from './ContactFormV3'

export const NEW_SALES_LEAD_FORM = 'web_flw-884_new_sales_lead_form'

export const useNewSalesLeadForm = () => {
  const bucket = useBucket(NEW_SALES_LEAD_FORM)
  return bucket === 'variant_1'
}

export const ContactForm = (props: {
  envName: string
  onClickSubmit?: () => void
}) =>
  useNewSalesLeadForm() ? (
    <ContactFormV3 {...props} />
  ) : (
    <ContactFormV2 {...props} />
  )
